import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../supabase';

export default function Profile() {
  const { user, login } = useAuth();
  const [refreshing, setRefreshing] = useState(false);
  const [refreshError, setRefreshError] = useState('');

  const refreshPoints = async () => {
    if (!user) return;
    setRefreshing(true);
    setRefreshError('');
    try {
      const { data: authRes, error: authErr } = await supabase.auth.getUser();
      if (authErr) throw new Error(authErr.message);
      const authUser = authRes?.user || null;

      let row = null;
      let lastErr = null;
      console.log('[Profile] Refresh points start', { authId: authUser?.id, email: user?.email });
      if (authUser?.id) {
        const { data, error } = await supabase
          .from('users')
          .select('loyalty_points,email')
          .eq('auth_id', authUser.id)
          .maybeSingle();
        if (error) {
          lastErr = error;
          console.warn('[Profile] auth_id query error', error);
        }
        if (!error && data) row = data;
      }

      if (!row && user?.email) {
        const { data, error } = await supabase
          .from('users')
          .select('loyalty_points')
          .eq('email', user.email)
          .maybeSingle();
        if (error) {
          lastErr = error;
          console.warn('[Profile] email query error', error);
        }
        if (!error && data) row = data;
      }

      if (!row) throw new Error(lastErr?.message || 'Impossibile aggiornare i punti.');

      const updated = {
        ...user,
        loyalty_points: row.loyalty_points ?? user.loyalty_points ?? 0,
      };
      // Persist refreshed points to context + localStorage
      login(updated);
    } catch (err) {
      setRefreshError(err.message || 'Errore durante l’aggiornamento.');
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className="form-container">
      <h2 className="yellow title">Profilo</h2>
      {user ? (
        <div>
          <p>
            <strong>Nome:</strong> {user.nome}
          </p>
          <p>
            <strong>Cognome:</strong> {user.cognome}
          </p>
          <p>
            <strong>Email:</strong> {user.email}
          </p>
          <p>
            <strong>Telefono:</strong> {user.telefono}
          </p>
          <p>
            <strong>Punti fedeltà:</strong> {user.loyalty_points ?? 0}
          </p>
          <button onClick={refreshPoints} disabled={refreshing}>
            {refreshing ? 'Aggiornamento…' : 'Aggiorna punti'}
          </button>
          {refreshError && <p className="error-message">{refreshError}</p>}
        </div>
      ) : (
        <p>Per vedere il tuo profilo, accedi o registrati prima!</p>
      )}
    </div>
  );
}